import { BusinessStore } from './business'
import { UIStore } from './ui'

export enum StoresEnum {
  uiStore = 'uiStore',
  businessStore = 'businessStore'
}

export class RootStore {
  uiStore: UIStore
  businessStore: BusinessStore

  constructor() {
    this.uiStore = new UIStore()
    this.businessStore = new BusinessStore()
  }
}

export const stores = new RootStore()
